<template>
  <div :class="['components-page__taskflow']">
    <!-- 开始节点 -->
    <nodeCard
      :config="organizerData"
      :is-delete="false"
      :is-arrow="false"
      :has-btn="true"
      class="start-node"
    >
      <div :class="['add-condition-box', isShowNode && 'pb-20', isDisabled]">
        <el-button
          class="add-condition-box-btn"
          type="text"
          round
          @click="onAddNode(0)"
        >
          添加审批人</el-button
        >
      </div>
    </nodeCard>
    <div v-show="isShowNode">
      <div
        :key="nodeIndex + '-node'"
        v-for="(node, nodeIndex) in auditDetail.flowList"
      >
        <nodeCard
          :config="getNodeConfig(node)"
          :has-btn="hasAddBtn(node)"
          @onAddNode="onAddNode(nodeIndex + 1)"
          @onDelete="onDeleteNode(nodeIndex)"
          @onEdit="onEditNode(node, nodeIndex)"
          :isDisabled="isDisabled"
        />
      </div>
    </div>
    <!-- 结束节点 -->
    <nodeWrapper>
      <div v-if="!isShowNode" :class="['add-condition-box', 'pb-20']" />
      <div class="end-node">
        <div class="end-node-circle" />
        <div class="end-node-text">流程结束</div>
      </div>
    </nodeWrapper>
    <nodeDialog
      v-if="nodeVisible"
      v-model="nodeVisible"
      :node-form="nodeForm"
      :mode="nodeMode"
      :node-index="nodeIndex"
      :isDisabled="isDisabled"
      @onConfirmNode="onConfirmNode"
      @change="changeNodeDialog"
    />
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import nodeCard from './nodeCard'
import nodeWrapper from './nodeWrapper'
import nodeDialog from './nodeDialog'
import { config } from '../../config'
import { getType } from '../utils'
import mixin from '../../../mixins/auditFlowManage'

const { nodeTypeMap } = config
export default {
  name: 'taskflow',
  mixins: [mixin],
  components: {
    nodeCard,
    nodeWrapper,
    nodeDialog,
  },
  props: {
    // eslint-disable-next-line vue/no-unused-properties
    type: {
      type: String,
      default: 'edit',
    },
    isDisabled: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      organizerData: {
        actionType: 5,
        content: '发起人',
      },
      nodeVisible: false,
      nodeIndex: 0,
      nodeCommonIndex: 0,
      nodeMode: 'create',
      nodeForm: {},
    }
  },
  computed: {
    isShowNode() {
      // flowList是每级审批人集合
      const {
        auditDetail: { flowList },
      } = this
      return flowList && flowList.length > 0
    },
  },

  methods: {
    ...mapMutations(['ADD_NODE', 'EDIT_NODE', 'DELETE_NODE']),

    hasAddBtn(node) {
      // 抄送人必须为最后一个节点，之后不能没有数据，不允许添加
      return getType(node.actionType) !== nodeTypeMap.CC_APPROVE
    },

    changeNodeDialog(val) {
      this.nodeVisible = val
    },

    onAddNode(nodeIndex, nodeMode = 'create') {
      // const { isShowNode } = this
      const { flowList } = this.auditDetail
      // if (isShowNode && nodeIndex === 0 && flowList.some(item => item.actionType !== 4)) return
      const auditFilter = flowList.filter(
        (item) => getType(item.actionType) !== nodeTypeMap.CC_APPROVE,
      )
      if (auditFilter.length >= 9) {
        this.$message({
          message: '审批节点已超过最大限制',
          type: 'warning',
        })
        return
      }
      this.nodeIndex = nodeIndex
      this.nodeMode = nodeMode
      this.nodeForm = {
        type: '',
        approverInfosList: [],
        method: '',
      }
      this.nodeVisible = true
    },

    onEditNode(node, nodeIndex, nodeMode = 'edit') {
      this.nodeIndex = nodeIndex
      this.nodeMode = nodeMode
      const { actionType = '', approverInfosList } = node
      const type = getType(actionType)
      const cconfig = {
        type,
        approverInfosList,
        method: '',
      }
      if ([nodeTypeMap.MULTIPLE_AND, nodeTypeMap.MULTIPLE_OR].includes(type)) {
        // 表示多人审批
        cconfig.type = nodeTypeMap.MULTIPLE_AND
        cconfig.method = type
      }
      this.nodeForm = cconfig
      this.nodeVisible = true
    },
    onDeleteNode(nodeIndex) {
      this.DELETE_NODE({ nodeIndex })
    },

    onConfirmNode(ruleForm) {
      const indexList = {
        nodeIndex: this.nodeIndex,
        nodeCommonIndex: this.nodeCommonIndex,
      }
      const { approverInfosList, method, type } = ruleForm
      const payload = {
        approverInfosList,
        actionType: method || type,
        ...indexList,
      }
      if (this.nodeMode === 'create') {
        this.ADD_NODE(payload)
        return
      }
      if (this.nodeMode === 'edit') {
        this.EDIT_NODE(payload)
      }
    },
    getNodeConfig(item) {
      const { accountList } = this
      const { actionType, approverInfosList } = item
      const data = {
        ...item,
        content: '',
      }
      // 审批类型处理
      const adminItem = accountList.find(
        (citem) => citem.adminUid === approverInfosList[0],
      )
      const adminName = (adminItem && adminItem.adminName) || ''

      const actionTypeMapper = new Map([
        [nodeTypeMap.SINGLE_APPROVE, adminName],
        [nodeTypeMap.MULTIPLE_AND, `${approverInfosList.length}人会签`],
        [nodeTypeMap.MULTIPLE_OR, `${approverInfosList.length}人或签`],
        [nodeTypeMap.CC_APPROVE, `${approverInfosList.length}人`],
      ])
      data.content = actionTypeMapper.get(actionType)
      return data
    },
  },
}
</script>

<style scoped lang="scss">
@import '../index.scss';
.components-page__taskflow {
  width: 100%;
  display: inline-block;
  position: relative;
  align-items: flex-start;
  flex-wrap: wrap;
  min-width: min-content; //min-content宽度表示的并不是内部那个宽度小就是那个宽度，而是，采用内部元素最小宽度值最大的那个元素的宽度作为最终容器的宽度
  margin-top: 24px;
  padding-bottom: 60px;
}

.add-condition-box {
  position: relative;
  width: 200px;
  display: inline-flex;
  flex-shrink: 0;
  padding-top: 40px;
  justify-content: center;

  &.pb-20 {
    padding-bottom: 20px;
  }

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 2px;
    height: 100%;
    background-color: #d8d8d8;
  }
  &-btn {
    height: 32px;
    border-radius: 32px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(10, 42, 97, 0.2);
    color: #2e7eff;
    padding: 6px 16px;
    z-index: 1;
    cursor: pointer;
    transition: all 0.3s;
    &:hover {
      border: 1px solid #2e7eff;
      box-shadow: 0px 2px 8px 0px rgba(46, 126, 255, 0.3);
    }
    &:active {
      border: 1px solid #2e7eff;
      box-shadow: none;
    }
  }
}

.end-node {
  border-radius: 50%;
  font-size: 14px;
  color: rgba(25, 31, 37, 0.4);
  text-align: left;
}

.end-node .end-node-circle {
  width: 10px;
  height: 10px;
  margin: auto;
  border-radius: 50%;
  background: #dbdcdc;
}

.end-node .end-node-text {
  margin-top: 5px;
  text-align: center;
}
</style>
